module.exports = __webpack_public_path__ + "img/sign-in-user.b113610d.png";